import { useState } from "react";

import {
    useServerClient, configuration as _configuration
} from "../useServerClient";
import { useServerParams } from "../useServerParams";

import { schedulerConfigs } from "./useSchedulers";

export const configuration = _configuration;

export const documentTypes = {
    salesOrder: "sales",
    proformaSales: "proforma_sales",
    cashSales: "cash_sales",
    retailCashSales: "retail_cash_sales",
    invoice: "invoices",
    retailPrescription: "retail_prescription",
    purchaseOrder: "purchase",
    deliveryOrder: "delivery",
    packingOrder: "packing_order",
    itemPicking: "item_picking",
    itemReceive: "item_receive",
    // itemReturn: "item_return",
    itemTransfer: "item_transfer",
    itemRepack: "item_repack",
    tripOrder: "trip",
    // profomaSale: "proforma_sales",
    salesDebitNote: "sales_debit_note",
    purchaseReturn: "purchase_return",
    salesCreditNote: "sales_credit_note",
    replacementDelivery: "replacement_delivery",
    itemRelocate: "item_relocate",
    itemTransform: "item_transform",
    purchaseInvoice: "purchase_invoice",
    itemIssue: "item_issue",
    itemAdjustment: "item_adjustment",
    stockTake: "stock_take",
    transferReturn: "transfer_return",
    transferRequisition: "transfer_requisition",
    salesInvoice: "sales_invoice",
    pickOrder: "pick_order"
};

export const targetTypes = {
    salesOrder: "sales",
    proformaSales: "proforma_sales",
    cashSales: "cash_sales",
    retailCashSales: "retail_cash_sales",
    invoice: "invoices",
    retailPrescription: "retail_prescription",
    purchaseOrder: "purchase",
    deliveryOrder: "delivery",
    packingOrder: "packing_order",
    itemPicking: "item_picking",
    itemReceive: "item_receive",
    // itemReturn: "item_return",
    itemTransfer: "item_transfer",
    itemRepack: "item_repack",
    tripOrder: "trip",
    // profomaSale: "proforma_sales",
    salesDebitNote: "sales_debit_note",
    purchaseReturn: "purchase_return",
    salesCreditNote: "sales_credit_note",
    replacementDelivery: "replacement_delivery",
    itemRelocate: "item_relocate",
    itemTransform: "item_transform",
    purchaseInvoice: "purchase_invoice",
    itemIssue: "item_issue",
    itemAdjustment: "item_adjustment",
    stockTake: "stock_take",
    transferReturn: "transfer_return",
    transferRequisition: "transfer_requisition",
    salesInvoice: "sales_invoice",
    pickOrder: "pick_order"
};

export const actionTypes = {
    itemReceive: {
        verifyIn: "ir_verify_in",
        unVerifyIn: "ir_unverify_in"
    },
    cashSales: {
        postToStock: "post_to_stock"
    },
    retailCashSales: {
        postToStock: "post_to_stock"
    }
};

// console.log('getSchedulerConfigs > integrationIds', integrationIds)

export function useDocuments({
    documentType: _documentType = "",
    targetType: _targetType = "",
    customEndpoint: _customEndpoint = "",
    actionType: _actionType = ""
}) {

    const [documentType, setDocumentType] = useState(_documentType);
    const [targetType, setTargetType] = useState(_targetType);
    const [actionType, setActionType] = useState(_actionType);
    const [customEndpoint, setCustomEndpoint] = useState(_customEndpoint);

    const { makeCall, serverClient, getError } = useServerClient();
    const {
        getListsUrl,
        getUrlWithDataTypes,
        _operatorDef: filterOperatorTypes
    } = useServerParams();

    const [isLoading, setIsLoading] = useState(false);

    const endpoint1 = "documents";
    const endpoint2 = "document";

    const list = async (props) => {

        setIsLoading(true);

        // option for configuration
        let configuration = props?.configuration;

        try {

            const {
                documentType: overrideDocumentType,
                customEndpoint: overrideCustomEndpoint
            } = props;

            let endpoint = `${endpoint1}/${documentType}`;

            if (overrideDocumentType) {
                endpoint = `${endpoint1}/${overrideDocumentType}`;
            }

            let url = getListsUrl(`${endpoint}`, props);

            if (targetType) {
                url = getListsUrl(`${endpoint}/${targetType}`, props);
            }

            // for custom endpoint
            if (customEndpoint) {
                url = getListsUrl(`${endpoint2}/${customEndpoint}`, props);
            }

            if (overrideCustomEndpoint) {
                url = getListsUrl(`${endpoint2}/${overrideCustomEndpoint}`,
                    props
                );
            }

            const response = await makeCall({
                url,
                method: "GET",
                payload: {},
                configuration
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            if (!serverClient.isCancel(error)) {
                setIsLoading(false);
                throw error;
            }
            else {
                setIsLoading(true);
            }
        }

        return true;

    };

    const create = async ({ data, targetType: overrideActionType, skipSchedulerRequestSubmit = false }) => {

        setIsLoading(true);

        try {

            const url = endpoint2;

            let payload = data

            if (skipSchedulerRequestSubmit === false) {
                // adding the scheduler request
                payload = {
                    ...payload,
                    ...schedulerConfigs.getSchedulerRequestSubmitObject(
                        schedulerConfigs.schedulerIntegrations)
                };
            }

            const postData = {
                scope: {
                    target: targetType,
                    action: ""
                },
                payload
            };

            if (overrideActionType) {
                postData.scope.target = overrideActionType;
            }

            const response = await makeCall({
                url,
                method: "POST",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    };

    const update = async ({ id, data, skipSchedulerRequestSubmit = false }) => {

        setIsLoading(true);

        try {

            const url = `${endpoint2}/${id}`;

            let payload = data

            if (skipSchedulerRequestSubmit === false) {
                // adding the scheduler request
                payload = {
                    ...payload,
                    ...schedulerConfigs.getSchedulerRequestSubmitObject(
                        schedulerConfigs.schedulerIntegrations)
                };
            }

            const postData = {
                scope: {
                    target: targetType,
                    action: ""
                },
                payload
            };

            const response = await makeCall({
                url,
                method: "PUT",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    };

    const remove = async ({
        ids,
        documentType: _documentType,
        targetType: _targetType,
        skipSchedulerRequestSubmit = false
    }) => {

        // blocked the retail or cash sales from remove - only cancel
        if (_documentType === documentTypes.retailCashSales || documentType ===
            documentTypes.retailCashSales) {
            throw new Error(
                `Remove document not supported for Retail Cash Sales`);
        }

        // blocked the retail or cash sales from remove - only cancel
        if (_documentType === documentTypes.cashSales || documentType ===
            documentTypes.cashSales) {
            throw new Error(`Remove document not supported for Cash Sales`);
        }

        // blocked the item transform from remove
        if (_documentType === documentTypes.itemTransform || documentType ===
            documentTypes.itemTransform) {
            throw new Error(
                `Remove document not supported for Item Transform`);
        }

        setIsLoading(true);

        if (ids.length <= 0) {
            throw getError(false, `Please select at least (1) items`);
        }

        try {

            let url = `${endpoint1}/delete`;

            if (_documentType) {
                url = `${endpoint1}/${_documentType}/delete`;
            }

            let payload = { ids }

            if (skipSchedulerRequestSubmit === false) {
                // adding the scheduler request
                payload = {
                    ...payload,
                    ...schedulerConfigs.getSchedulerRequestSubmitObject(
                        schedulerConfigs.schedulerIntegrations)
                };
            }

            const postData = {
                scope: {
                    target: targetType
                },
                payload
            };

            if (_targetType) postData.scope.target = _targetType;

            const response = await makeCall({
                url,
                method: "POST",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    };

    const cancel = async ({
        ids,
        documentType: _documentType,
        targetType: _targetType
    }) => {

        // blocked the retail or cash sales from remove - only cancel
        if (_documentType) {
            if (_documentType !== documentTypes.cashSales && _documentType !==
                documentTypes.retailCashSales) {
                throw new Error(
                    `Cancel document not supported for ${_documentType}`);
            }
        }

        if (documentType) {
            if (documentType !== documentTypes.cashSales && documentType !==
                documentTypes.retailCashSales) {
                throw new Error(
                    `Cancel document not supported for ${documentType}`);
            }
        }

        setIsLoading(true);

        if (ids.length <= 0) {
            throw getError(false, `Please select at least (1) items`);
        }

        try {

            let url = `${endpoint1}/cancel`;

            if (_documentType) {
                url = `${endpoint1}/${_documentType}/cancel`;
            }

            const postData = {
                scope: {
                    target: targetType
                },
                payload: {
                    ids
                }
            };

            if (_targetType) postData.scope.target = _targetType;

            const response = await makeCall({
                url,
                method: "POST",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    };

    const get = async ({
        id,
        documentType: overrideDocumentType,
        dataTypesArray = []
    }) => {

        setIsLoading(true);

        try {

            let url = `${endpoint2}/${documentType}/${id}`;

            if (overrideDocumentType) {
                url = `${endpoint2}/${overrideDocumentType}/${id}`;
            }

            if (dataTypesArray.length) {
                url = getUrlWithDataTypes(`${url}`, dataTypesArray);
            }

            const response = await makeCall({
                url,
                method: "GET",
                payload: {}
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    };

    // for retail cash sales only
    const stockPost = async ({ id, data }) => {

        if (
            documentType !== documentTypes.cashSales &&
            documentType !== documentTypes.retailCashSales
        ) {
            throw new Error(`Unsupport stock post action : ${documentType}`);
        }

        setIsLoading(true);

        try {

            const url = `${endpoint2}/${id}`;

            const postData = {
                scope: {
                    target: targetType,
                    action: actionType
                },
                payload: data
            };

            const response = await makeCall({
                url,
                method: "PUT",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    };

    return {
        filterOperatorTypes,
        isLoading,
        list,
        get,
        create,
        update,
        remove,
        cancel,
        stockPost
    };
}